export default __webpack_public_path__ + "static/media/profile.ad338e95.svg";